module.exports = __webpack_public_path__ + "img/kitchen-arch-terracotta.a7143f40.webp";